import VueRouter from "vue-router";
import user from "@/user";
const router = new VueRouter({
  routes: [
    { path: "*", redirect: "/" },
    {
      path: "/",
      redirect: "/log-in",
    },
    {
      path: "/log-in",
      name: "logIn",
      meta: {
        requiresAuth: false,
        nextRoute: { name: "subscription" },
        backLink: "/",
        useInnerBlock: false,
      },
      component: () => import("@/couples/pages/LogIn.vue"),
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      meta: {
        requiresAuth: false,
        useInnerBlock: false,
      },
      component: () => import("@/pages/ForgotPassword.vue"),
    },
    {
      path: "/user",
      redirect: "/user/subscription",
      component: () => import("@/pages/FadingRouter.vue"),
      children: [
        {
          path: "subscription",
          name: "subscription",
          meta: {
            requiresAuth: true,
          },
          component: () => import("@/couples/pages/Subscription.vue"),
        },
        {
          path: "cancel",
          redirect: "cancel/reason",
          component: () => import("@/pages/FadingRouter.vue"),
          children: [
            {
              path: "reason",
              name: "cancelReason",
              meta: {
                requiresAuth: true,
                requiresSubscription: true,
              },
              component: () => import("@/couples/pages/CancelReason.vue"),
            },
            {
              path: "value",
              name: "cancelValue",
              meta: {
                requiresAuth: true,
                requiresSubscription: true,
              },
              component: () => import("@/couples/pages/CancelValue.vue"),
            },
            {
              path: "offer",
              name: "cancelOffer",
              meta: {
                requiresAuth: true,
                requiresSubscription: true,
              },
              component: () => import("@/couples/pages/CancelOffer.vue"),
            },
            {
              path: "confirm",
              name: "cancelConfirm",
              meta: {
                requiresAuth: true,
                requiresSubscription: false,
              },
              component: () => import("@/couples/pages/CancelConfirm.vue"),
            },
            {
              path: "confirmation",
              name: "cancelConfirmation",
              meta: {
                requiresAuth: true,
                requiresSubscription: false,
              },
              component: () => import("@/couples/pages/CancelConfirmation.vue"),
            },
            {
              path: "rescue-confirmation",
              name: "rescueConfirmation",
              meta: {
                requiresAuth: true,
                requiresSubscription: true,
              },
              component: () => import("@/couples/pages/RescueConfirmation.vue"),
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && (!user.isLoggedIn() || !user.user)) {
    next({ name: "logIn", query: { redirect: to.path } });
    return;
  } else if (to.meta.requiresSubscripion && !user.hasActiveSubscription()) {
    next({ name: "subscription" });
    return;
  }
  next();
});

export default router;
